import { IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { SnackbarAction, SnackbarKey } from 'notistack'
import React, { FC, MouseEvent, useCallback } from 'react'
import styled from 'styled-components'

export interface PatientBrowseDispensaryToastActionsProps {
  snackbarKey: SnackbarKey
  dismissToast: () => void
}

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

export const getPatientBrowseDispensaryToastActions = (
  props: Omit<PatientBrowseDispensaryToastActionsProps, 'snackbarKey'>,
): SnackbarAction => {
  const Actions = (snackbarKey: SnackbarKey) => {
    return <PatientBrowseDispensaryToastActions snackbarKey={snackbarKey} {...props} />
  }
  return Actions
}

export const PatientBrowseDispensaryToastActions: FC<PatientBrowseDispensaryToastActionsProps> = ({
  dismissToast,
}) => {
  const onClickClose = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.preventDefault()
      event.stopPropagation()
      dismissToast()
    },
    [dismissToast],
  )

  return (
    <CloseButton size="small" aria-label="close" color="inherit" onClick={onClickClose}>
      <CloseIcon fontSize="small" />
    </CloseButton>
  )
}
